import React from 'react';
import PropTypes from 'prop-types';
import { RadioInput } from 'uikit/inputs';

import { registerField } from 'core/forms';

const FormFieldRadioInput = ({
  fieldId,
  fieldKey,
  schema = { label: '', options: [] },
  updateField,
  value = '',
}) => (
  <RadioInput
    fieldId={fieldId}
    fieldKey={schema.inputName || fieldKey}
    options={schema.options?.map((optionSchema) => ({
      ...optionSchema,
      isDisabled: optionSchema.isDisabled || schema.isDisabled,
    }))}
    labelPosition="right"
    label={schema.label}
    value={value}
    updateField={updateField}
  />
);

FormFieldRadioInput.propTypes = {
  fieldId: PropTypes.string.isRequired,
  fieldKey: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  schema: PropTypes.shape({
    inputName: PropTypes.string,
    label: PropTypes.string,
    isDisabled: PropTypes.bool,
    options: PropTypes.array,
  }),
  updateField: PropTypes.func.isRequired,
};

registerField('Radio', React.memo(FormFieldRadioInput));

export default FormFieldRadioInput;
